import React from 'react';
import ArticleMeta from '../ArticleMeta';

interface ArticleCardMetaProps {
  author?: string;
  createdAt?: string;
  className?: string;
}

function ArticleCardMeta({
  author,
  createdAt,
  className,
}: ArticleCardMetaProps) {
  return (
    <ArticleMeta
      className={className}
      authorName={author}
      infos={createdAt ? [createdAt] : null}
      size="medium"
    />
  );
}

export default ArticleCardMeta;
